/**
 * Adapted from this gist:
 * https://gist.github.com/eyedean/ce6ab6a5108a1bd19ace64382144b5b0
 *
 * Vue Router documentation on Navigation failures:
 * https://v3.router.vuejs.org/guide/advanced/navigation-failures.html
 *
 * This augments the VueRouter.push() method to swallow any "redirected"
 * Navigation failures, while still throwing actual errors if navigation fails.
 */
import VueRouter, { RawLocation, Route } from 'vue-router';
import { ErrorHandler } from 'vue-router/types/router';

let isAugmented = false;

export function augmentVueRouterPush(): void {
	if (isAugmented) {
		return;
	}
	isAugmented = true;

	const originalPush = VueRouter.prototype.push; // eslint-disable-line @typescript-eslint/unbound-method
	function augmentedPush(location: RawLocation): Promise<Route>;
	function augmentedPush(location: RawLocation, onResolve?: Function, onReject?: ErrorHandler): void; // eslint-disable-line @typescript-eslint/ban-types
	function augmentedPush(
		this: VueRouter,
		location: RawLocation,
		onResolve?: Function, // eslint-disable-line @typescript-eslint/ban-types
		onReject?: ErrorHandler
	): void | Promise<Route> {
		const boundOriginalPush = originalPush.bind(this);
		if (onResolve || onReject) {
			return boundOriginalPush(location, onResolve, onReject);
		} else {
			/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
			return boundOriginalPush(location).catch((err: any) => {
				if (VueRouter.isNavigationFailure(err, VueRouter.NavigationFailureType.redirected)) {
					return Promise.resolve(err.from);
				}

				return Promise.reject(err);
			});
		}
	}

	VueRouter.prototype.push = augmentedPush;
}
